import { DocumentData, DocumentReference } from "@angular/fire/firestore";

export class VenueSummary {
  public readonly name: string;
  public readonly reference: DocumentReference;
  public readonly id: string;

  constructor(
    data: DocumentData,
    name?: string,
    reference?: DocumentReference,
    id?: string
  ) {
    if (data != null) {
      this.name = data.name;
      this.reference = data.reference as DocumentReference;
      this.id = id;
    } else {
      this.name = name;
      this.reference = reference;
      this.id = id;
    }
  }
}
